module.exports = __webpack_public_path__ + "img/team2.b9d799ff.png";